module.exports = __webpack_public_path__ + "img/zhxy_image_14.cd006e0e.png";